/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : policiesActions.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const policiesActions = {
  add_policies: {
    api_name: "/UCM/policies/",
    action_type: actionType.ADD_POLICIES,
    https_method: "POST",
    description: "",
  },
  get_policies: {
    api_name: "/UCM/policies",
    action_type: actionType.GET_POLICIES,
    https_method: "GET",
    description: "",
  },
  get_policies_key_actions: {
    api_name: "/UCM/actions/catalog",
    action_type: actionType.GET_ACTIONS,
    https_method: "GET",
    description: "",
  },
  update_policies: {
    api_name: "/UCM/policies/{policyKey}/versions",
    action_type: actionType.UPDATE_POLICIES,
    https_method: "POST",
    description: "",
  },
  delete_policies: {
    api_name: "/UCM/policies/{policyKey}/rollback/",
    action_type: actionType.DELETE_POLICIES,
    https_method: "POST",
    description: "",
  },

  get_domains: {
    api_name: "/UCM/actions/domains",
    action_type: actionType.GET_DOMAINS,
    https_method: "GET",
    description: "",
  },
};




export default policiesActions;
